export default __webpack_public_path__ + "static/media/dfl-5-rMIN.7b4b6bbc.avif";